import { RouteProp } from '@react-navigation/native';
import React from 'react';
import { ActivityTabNavigationParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import { ActionButtonLayout } from '../../../../v2BaseComponents/ActionButtonLayout';
import AuditLogDetails, { useDeleteAuditLogActionButton } from '../../../../shared/AuditLogDetails';

export type AuditLogDetailsScreenOwnProps = {};

export type AuditLogDetailsScreenProps = AuditLogDetailsScreenOwnProps & {
    route: RouteProp<ActivityTabNavigationParamList, 'details'>;
};

const AuditLogDetailsScreen: React.FC<AuditLogDetailsScreenProps> = ({
    route: {
        params: { auditLogId, profileId },
    },
}) => {
    const goBack = useGoBack();
    const { deleteAuditLogAction } = useDeleteAuditLogActionButton({
        auditLogId,
        medicalProfileFileId: profileId,
        onDeleted: goBack,
    });

    return (
        <ActionButtonLayout scrollable actions={[deleteAuditLogAction]}>
            <AuditLogDetails auditLogId={auditLogId} profileId={profileId} />
        </ActionButtonLayout>
    );
};

export default React.memo(AuditLogDetailsScreen);
